import styled from 'styled-components'

import { Input } from '../Input'

export const InputCpfCnpj = styled(Input)``
